<template>
  <div class="products">
    <div style="margin-bottom: 10px;">
      <el-text style="font-size: larger; font-weight: bolder;">{{ util.language('商品', 'Product') }}</el-text>
    </div>
    <el-form :inline="true">
      <el-form-item :label="util.language('编码', 'Code')">
        <el-input style="width: 120px;" :placeholder="util.language('模糊匹配', 'Fuzzy')" v-model="searchParam.codeLike" clearable />
      </el-form-item>
      <el-form-item :label="util.language('名称', 'Name')">
        <el-input style="width: 120px;" :placeholder="util.language('模糊匹配', 'Fuzzy')" v-model="searchParam.nameLike" clearable />
      </el-form-item>
      <el-form-item :label="util.language('类型', 'Type')">
        <el-select filterable clearable v-model="searchParam.typeId" style="width: 120px;">
          <el-option v-for="item in show.productTypes" :key="item.id" :label="util.language(item.cnName, item.enName)" :value="item.id" />
        </el-select>
      </el-form-item>
      <el-form-item :label="util.language('状态', 'State')">
        <el-select clearable v-model="searchParam.state" style="width: 120px;">
          <el-option :key="1" :label="util.language('曾启用', 'Used')" :value="1" />
          <el-option :key="2" :label="util.language('未曾启用', 'Unused')" :value="2" />
          <el-option :key="3" :label="util.language('启用', 'Enable')" :value="3" />
          <el-option :key="4" :label="util.language('停用', 'Disable')" :value="4" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="commitFindList()" :loading="loading.find">{{ util.language('搜索', 'Search') }}</el-button>
          <el-tooltip :content="util.language('按当前筛选条件导出', 'Export by current search condition')" placement="top">
            <el-button type="warning" @click="exportExcel()" :loading="loading.exportExcel">{{ util.language('导出', 'Export') }}</el-button>
          </el-tooltip>
          <el-button @click="resetSearchParam()">{{ util.language('重置', 'Reset') }}</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="info" @click="show.importShow = true">{{ util.language('导入', 'Import') }}</el-button>
          <el-button type="primary" @click="add()">{{ util.language('新增', 'New') }}</el-button>
          <el-button type="warning" :disabled="show.selected.length != 1" @click="update()">{{ util.language('详情', 'Detail') }}</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="data.productList" @selection-change="selectionChange()" ref="tabRef" border style="height: calc(100vh - 220px);" v-loading="loading.find">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column label="ID" width="70" align="center">
        <template #default="scope">
          <el-link type="primary" @click="update(scope.row)">{{ scope.row.id }}</el-link>
        </template>
      </el-table-column>
      <el-table-column :label="util.language('商品', 'Product')" min-width="100">
        <template #default="scope">
          <div style="display: flex;">
            <div style="width: 70px; height: 70px; background-color: antiquewhite;">
              <el-image style="width: 100%; height: 100%;" :src="scope.row.img" fit="cover" />
            </div>
            <div style="margin-left: 10px;">
              <el-tag v-if="!scope.row.shopId" type="warning">{{ util.language('未曾启用', 'Unused') }}</el-tag>
              <template v-else>
                <el-tag v-if="scope.row.enable" type="success">{{ util.language('启用', 'Enable') }}</el-tag>
                <el-tag v-else type="danger">{{ util.language('停用', 'Disable') }}</el-tag>
              </template>
              <el-text style="margin-left: 10px;">{{ scope.row.code }}</el-text>
              <el-tag type="primary" v-if="scope.row.hasUnit" style="margin-left: 10px;">{{ util.language('按单位（称重）', 'Unit(Weight)') }}</el-tag>
              <el-tag type="success" v-if="!scope.row.hasTax" style="margin-left: 10px;">{{ util.language('免税', 'No tax') }}</el-tag>
              <br />
              <el-text>{{ scope.row.enName }}</el-text>
              <br />
              <el-text>{{ scope.row.cnName }}</el-text>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="unitPriceIn" :label="util.language('进价', 'Purchase price')" align="right" width="100" show-overflow-tooltip>
        <template #default="scope">
          {{ math.formatNumber(scope.row.unitPriceIn) }}
        </template>
      </el-table-column>
      <el-table-column prop="unitPrice" :label="util.language('售价', 'Sale price')" align="right" width="100" show-overflow-tooltip>
        <template #default="scope">
          {{ math.formatNumber(scope.row.unitPrice) }}
        </template>
      </el-table-column>
      <el-table-column prop="pieceInventoryQuantity" :label="util.language('库存件数', 'Inventory Qty')" align="right" width="100" show-overflow-tooltip />
      <el-table-column prop="unitPerPiece" :label="util.language('单位', 'Unit')" align="right" width="140" show-overflow-tooltip>
        <template #default="scope">
          {{ math.formatNumber(scope.row.unitPerPiece) + ' ' + scope.row.unit + '/' + util.language('件', 'piece') }}
        </template>
      </el-table-column>
      <el-table-column prop="orderBy" :label="util.language('排序', 'Sort')" width="60" show-overflow-tooltip />
      <el-table-column :label="util.language('操作', 'Operation')" align="center" width="140">
        <template #default="scope">
          <el-link type="primary" @click="inventoryHistory(scope.row)">{{ util.language('库存历史', 'Inventory history') }}</el-link>
        </template>
      </el-table-column>
    </el-table>
    <div style="height: 10px;" />
    <el-pagination v-model:current-page="searchParam.pageNum" v-model:page-size="searchParam.pageSize" :page-sizes="[50, 100, 200]" background layout="total, sizes, prev, pager, next, jumper" :total="data.productTotal" @change="commitFindList()" />
  </div>

  <el-dialog v-model="show.importShow" :title="util.language('确认导入', 'Confirm import')" width="600">
    <el-form>
      <el-form-item>
        <el-text>{{ util.language('请先', 'Please ') }}</el-text>
        <el-link type="primary" @click="importExcelTemplate()">{{ util.language('下载导入模版', 'Download import template ') }}</el-link>
        <el-text>{{ util.language('，填写模板内容再导入。', 'first, then fill in the template content and import.') }}</el-text>
        <br>
        <el-text type="danger">{{ util.language('模板格式不对应可能造成导入数据混乱，请注意。', 'The template format may cause the imported data to be disordered.') }}</el-text>
      </el-form-item>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-upload :loading="loading.importExcel" :action="api.baseURL() + '/backend/product/importExcel'" :headers="api.tokenHeader()" :on-progress="importExcelProgress" :on-success="importExcelSuccess" :on-error="importExcelError"
          :show-file-list="false">
          <el-button type="primary">{{ util.language('导入', 'Import') }}</el-button>
        </el-upload>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import apiNative from '../../apis/apiNative'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const shopId = cache.getObject(cache.keys.shopId)
if (!shopId) {
  ElMessage.error(util.language('请先选择店铺', 'Please select a shop first'))
}
const router = useRouter()
const tabRef = ref()

const loading = reactive({
  find: false,
  exportExcel: false,
  importExcel: false,
})
const data = reactive({
  productList: [],
  productTotal: 0,
})

const show = reactive({
  importShow: false,
  selected: [],
  productTypes: [],
})

api.get('/backend/product/getProductType').then(res => {
  show.productTypes = res.list
})

const searchParam = reactive({})
const resetSearchParam = () => {
  searchParam.pageNum = 1
  searchParam.pageSize = 50
  searchParam.shopId = shopId
  searchParam.codeLike = ''
  searchParam.nameLike = ''
  searchParam.typeId = null
  searchParam.state = 3
}
resetSearchParam()

const buildSearchParam = () => {
  const params = JSON.parse(JSON.stringify(searchParam))
  if (params.state) {
    if (params.state == 1) {
      params.hasUsed = true
    }
    if (params.state == 2) {
      params.hasUsed = false
    }
    if (params.state == 3) {
      params.enable = true
    }
    if (params.state == 4) {
      params.enable = false
    }
    params.state = null
  }
  return params
}

const commitFindList = () => {
  loading.find = true
  const params = buildSearchParam()
  api.get('/backend/product/getProductPage', { params }).then(res => {
    data.productList = res.list
    data.productTotal = res.total
  }).finally(() => {
    loading.find = false
  })
}
commitFindList()

const selectionChange = () => {
  show.selected = tabRef.value.getSelectionRows()
}

const add = () => {
  cache.setObject(cache.keys.pageParam + 'product', null)
  router.push('/product')
}

const update = (row) => {
  const product = row ? row : tabRef.value.getSelectionRows()[0]
  cache.setObject(cache.keys.pageParam + 'product', product)
  router.push('/product')
}

/** 库存历史 */
const inventoryHistory = (row) => {
  const inventoryHistoriesParam = {
    productCode: row.code,
  }
  cache.setObject(cache.keys.pageParam + 'inventoryHistories', inventoryHistoriesParam)
  router.push('/inventoryHistories')
}

/** 下载导入模板 */
const importExcelTemplate = () => {
  apiNative.get('/backend/product/importExcelTemplate', {
    responseType: 'blob'
  }).then(res => {
    const fileName = res.headers['content-disposition'].split(';')[1].split('=')[1]
    ElMessage.info(util.language('开始下载', 'downloading'))
    util.downloadFile(res.data, fileName)
  })
}

/** 导入中 */
const importExcelProgress = () => {
  loading.importExcel = true
  ElMessage.success(util.language('正在导入！如果数据量大可能时间较长，请耐心等待。', 'Importing! If the data is large, it may take a long time. Please be patient.'))
}

/** 导入完成 */
const importExcelSuccess = (res) => {
  loading.importExcel = false
  if (res.code != 'S000001') {
    ElMessage.error(util.language('导入失败，请联系系统管理员', 'Import failed, please contact the system administrator'))
    return
  }
  show.importShow = false
  let cnMessage = '<p>本次导入，共计识别到：' + res.data.all + '条数据</p>'
  cnMessage += '<p>成功：<span style="color:green"> ' + res.data.success + ' </span>条数据</p>'
  cnMessage += '<p>失败：<span style="color:red"> ' + res.data.error + ' </span>条数据</p>'
  if (res.data.error > 0) {
    for (const failIndex in res.data.failRowList) {
      cnMessage += '<p>第 ' + res.data.failRowList[failIndex].row + ' 行：' + res.data.failRowList[failIndex].reason + '</p>'
    }
  }
  let enMessage = '<p>Total number of data recognized this time: ' + res.data.all + ' </p>'
  enMessage += '<p>Successful：<span style="color:green"> ' + res.data.success + ' </span>data</p>'
  enMessage += '<p>Failed：<span style="color:red"> ' + res.data.error + ' </span>data</p>'
  if (res.data.error > 0) {
    for (const failIndex in res.data.failRowList) {
      enMessage += '<p>Row ' + res.data.failRowList[failIndex].row + ': ' + res.data.failRowList[failIndex].reason + '</p>'
    }
  }
  let message = util.language(cnMessage, enMessage)
  ElMessageBox.alert('', {
    title: util.language('导入完成', 'Import completed'),
    message: message,
    autofocus: false,
    dangerouslyUseHTMLString: true,
    confirmButtonText: util.language('确定', 'Confirm'),
  })
  res.data
}

/** 导入失败 */
const importExcelError = () => {
  loading.importExcel = false
  ElMessage.error(util.language('导入失败，请联系系统管理员', 'Import failed, please contact the system administrator'))
}

/** 导出表格 */
const exportExcel = () => {
  loading.exportExcel = true
  const params = buildSearchParam()
  apiNative.get('/backend/product/exportExcel', { params, responseType: 'blob' }).then(res => {
    const fileName = res.headers['content-disposition'].split(';')[1].split('=')[1]
    ElMessage.info(util.language('导出完成，开始下载', 'Export completed, downloading'))
    util.downloadFile(res.data, fileName)
  }).finally(() => {
    loading.exportExcel = false
  })
}
</script>

<style lang="less"></style>